import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
// Iconos apropiados para servicios
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import { Dashboard } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import HttpsIcon from '@mui/icons-material/Https';

import { message } from 'antd';

function Admin() {
  const [permissionError, setPermissionError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate();

  const checkPermissions = async () => {
    const token = localStorage.getItem('token');
      if (!token) {
        messageApi.error('No se encontró el token de autenticación.');
        setPermissionError(true);
        window.location.href = '/sign-in'; // Redirect to login if no token
        return;
      }
      setPermissionError(false);
      setIsLoading(true);
      try {
        const response = await fetch('https://dprincess-training.servehttp.com/users/check-permissions', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        if (response.status === 403) {
          messageApi.error('No tienes permisos para acceder a esta sección.');
          setPermissionError(true);
          throw new Error('No tienes permisos para acceder a esta sección.');
        }
      } catch (error) {
        messageApi.error(error.message || 'Error al verificar permisos.');
        throw error; // Re-throw to handle it in the calling function
      } finally {
        setIsLoading(false);
      }
  };

  const cardStyle = {
    maxWidth: 275,
    height: 180,
    boxShadow: '0 4px 12px rgba(75, 0, 130, 0.15)',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(75, 0, 130, 0.25)',
    }
  };

  const iconStyle = {
    fontSize: 40,
    color: '#4b0082',
    opacity: 0.8
  };

  const serviceMenuOptions = [
    {
      title: 'Dashboard',
      description: 'Resumen ejecutivo y analítico de eventos, ingresos, inventario y métricas clave de la administración.',
      path: `/administration/dashboard`,
      icon: <Dashboard sx={iconStyle} />
    },
    {
      title: 'Modificar Empleados',
      description: 'Listar y modificar las cuentas de empleados existentes.',
      path: `/administration/modify-employees`,
      icon: <EditIcon sx={iconStyle} />
    },
    {
      title: 'Registrar Empleado',
      description: 'Registrar cuenta de empleado con acceso al sistema.',
      path: `/administration/add-employees`,
      icon: <LibraryAddIcon sx={iconStyle} />
    },
  ];

  const handleNavigate = (path) => {
    if (path) {
      setTimeout(() => {
        navigate(path)
      }, 100)
    }
  }

  useEffect(() => {
    checkPermissions();
  }, []);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Mostrar mensaje de falta de permisos si corresponde
  if (permissionError) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2
        }}>
          <Avatar sx={{ bgcolor: '#f44336', width: 64, height: 64 }}>
            {/* Icono de candado para indicar acceso restringido */}
            <HttpsIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography variant="h5" sx={{ color: '#f44336', fontWeight: 700 }}>
            No tienes permiso para acceder a esta sección
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', textAlign: 'center' }}>
            Esta información solo está disponible para usuarios con permisos de administrador.
          </Typography>
        </Box>
      </Container>
    );
  };

  return (
    <div className='events-menu-main-container'>
      {contextHolder}
      <div className='events-menu-container'>
        {serviceMenuOptions.length > 0 && serviceMenuOptions.map((option, index) => (
          <div className='event-reservation grid-obj' key={index}>
            <Card sx={cardStyle}>
              <CardActionArea sx={{ height: 200 }} onClick={() => handleNavigate(option.path)}>
                <CardContent sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: 150,
                  justifyContent: 'space-between',
                  padding: '20px'
                }}>
                  <div className='content-container'>
                    <Typography sx={{
                      color: '#4b0082',
                      fontWeight: 'bold',
                      marginBottom: '8px'
                    }} gutterBottom variant="h5" component="div">
                      {option.title}
                    </Typography>
                    <Typography variant="body2" sx={{
                      color: 'text.secondary',
                      lineHeight: 1.4,
                      textAlign: 'justify'
                    }}>
                      {option.description}
                    </Typography>
                  </div>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {option.icon}
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Admin